import { SET_GENERATED_TEAM_NAMES, SHOW_LOADING_SPINNER } from '../actions/teamNameGeneratorActions';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

export default function teamNameGeneratorReducer(state: any = {}, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case SET_GENERATED_TEAM_NAMES: {
      return {
        ...state,
        ...action.payload
      };
    }
    case SHOW_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    default:
      return state;
  }
}
